import type { Action } from '../action'
import { ResourceType } from '../resource-type'

/**
 * Using the client app, as opposed to administering it: a resource the user
 * can access appears in their nav (`me`) and they can work in it.
 *
 * `me` counts only grants that name a tenant, so a platform admin's `*` puts
 * nothing in their nav until they grant themselves access to a tenant
 */
export const CLIENT_ACTIONS = {
  'client:tenant:access': {
    description: 'Open this tenant in the client app',
    resourceTypes: [ResourceType.Tenant],
  },
  'client:zone:access': {
    description: 'Open this zone in the client app',
    resourceTypes: [ResourceType.Zone],
  },
  'client:app:access': {
    description: 'Open this app in the client app',
    resourceTypes: [ResourceType.App],
  },
  'client:scenario:access': {
    description: 'Open this scenario in the client app',
    resourceTypes: [ResourceType.Scenario],
  },
  /**
   * An app's pages each need this as well as `client:app:access` on the app —
   * `app_<id>:*` grants both. Restricts a user to some of an app's pages
   */
  'client:page:access': {
    description: 'Open this page of an app in the client app',
    resourceTypes: [ResourceType.Page],
  },
  /**
   * Seeing the agent, as opposed to chatting with it (`agent:chat:invoke`).
   * Shown on every page of the tenant, zone or app its URN names
   */
  'client:agent:access': {
    description: 'Show this agent in the client app',
    resourceTypes: [ResourceType.Agent],
  },
  'client:user:list': {
    description: 'List the users of this tenant, zone, app or scenario',
    resourceTypes: [
      ResourceType.Tenant,
      ResourceType.Zone,
      ResourceType.App,
      ResourceType.Scenario,
    ],
  },
} as const satisfies Record<string, Action.Definition>
